<div class="migrate-container">
  <section>
    <app-loading *ngIf="isLoading" />
    <app-migration-sign-up
      [email]="email"
      [oldPassword]="oldPassword"
      [token]="token"
      [username]="username"
    />
  </section>
</div>
